import { useContext } from 'react';
import {
  CapacityCancellationContext,
  CapacityCancellationContextValue,
} from './CapacityCancellationContext';

const useCapacityCancellationContext = (): CapacityCancellationContextValue => {
  const context = useContext(CapacityCancellationContext);
  if (!context) {
    throw new Error(
      'useCapacityCancellationContext must be used within CapacityCancellationProvider'
    );
  }
  return context;
};

export default useCapacityCancellationContext;
